import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Logger } from 'angular2-logger/core';
import { segmentsService } from '../segments.service';
import { SharedService } from '../../../shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-segments-edit',
  templateUrl: './segments-edit.component.html',
  styleUrls: ['../../admin/admin.component.scss']
})
export class segmentsEditComponent implements OnInit {

	public form: FormGroup;
	public tags_id: string;
	
  constructor(
	private _segmentsService: segmentsService,
    private _sharedService: SharedService,
    public toastr: ToastsManager,
    private _router: Router,
	private activatedRoute: ActivatedRoute,
	private fb: FormBuilder,
	private spinner: NgxSpinnerService,
    private logger: Logger) {
		this.activatedRoute.params.subscribe(params => {
			this.tags_id = params['id'];
		});

		this.form = this.fb.group({
			id: [this.tags_id],
			detalle: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(60)]],
			avaliable: ['', [Validators.required]]
		});
    }

	ngOnInit() {
		this.loadStatusData();
	}

	loadStatusData() {
		this.spinner.show();
		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			id: this.tags_id
		};

		// initialized the status
		/* this._segmentsService.getSegments(data).subscribe(
			data => {
				this.logger.log(data);
				if (data.status) {
					this.form.setValue({
						id: data.data.tags,
						detalle: data.data.tags.description,
						avaliable: data.data.tags.status,
					});
					this.spinner.hide();

				} else {
					this.toastr.error(data.message, 'Error');
					this.spinner.hide();
				}
			
			},
			error => {
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo.', 'Error');
				this.logger.log(error);

			} */
		//);
	}

	onEdit() {
		/* this.spinner.show();
		console.log(this.form.value);

		let data = {
			auth_token: this._sharedService.getCookie('auth_token'), // get cookie
			id: this.tags_id,
			detalle : this.form.value.detalle,
			avaliable : this.form.value.avaliable
		};

		this._segmentsService.editTags(data).subscribe(
			data => {
				if (data.status) {
					this.toastr.success('La etiqueta ha sido actualizada correctamente!', '¡Éxito!');
					this.onCancel();
				} else {
					this.toastr.error(data.message, 'Error');
				}
			},
			error => {
				this.spinner.hide();
				this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
				this.logger.log(error);
			}
		); */
	}

	onCancel() {
		return this._router.navigate(['./admin/tags/list']);
	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/segments/segments-edit/segments-edit.component.ts